import en from './en.json'
import fr from './fr.json'
import de from './de.json'
import ar from './ar.json'

export const Lang = {en, fr, de, ar}
